import {observable, action, runInAction} from 'mobx'
import {json, get} from "../../../../utils/ajax";
import {message} from 'antd'
import uuid from "uuid/v4";
import {
    _encodeParamToSearch, downLoad,
    handleSearchAndPage,
    objToValueObj,
    setStore,
    ValueObjToObj
} from '../../../../utils/Utils'
import moment from "moment"

class epcSparepartChangeStore {
    @observable list//主页面数据
    @observable loading//页面加载
    @observable carserData//获取车系名称
    @observable isShowModal//是否显示模态框
    @observable homePageFormData//查询条件
    @observable tableData//添加/修改中的table数据
    @observable editFields //将模态框页面的值绑定到store
    @observable initCarCode
    @observable changeGroupingName//对应组数据
    @observable judgeState//判断是新增还是修改
    @observable echoDisplayData//修改时回显数据
    @observable editingKey//当前编辑行的key
    @observable carCodeData//将模态框Table的值绑定到store
    @observable saveCarceriesMapCode //保存Table中选中车系的code
    @observable catalogCodesData//点击修改时table分组号
    @observable modalLoading//模态框数据加载
    @observable pagination//分页
    @observable page//分页
    @observable noticeNameSelectData//通知书名称搜索的数据
    @observable fetching//匹配内容是否为空
    @observable selectNoticeData//与搜索条件匹配的数据
    @observable selectLetterCode//通知书名称选中的code
    @observable selectLetterName//通知书名称选中的名称
    @observable cover//修改时替换件物料编号失去焦点时覆盖右边分组号
    @observable onSearchCatalogIdListData//组号发生变化时
    @observable audiModal//对应车系弹框
    @observable selectedRowKeysId//获取勾选行的id
    @observable groupModal//对应组弹框
    @observable selectedGroupRowKeysId//获取勾选对应组行的id
    @observable groupList//对应组模态框列表数据
    @observable groupeditFields//将模态框页面的值绑定到store
    @observable getGroupData//点击对应组时车系下拉数据
    @observable groupLoading//对应组数据加载
    @observable catalogIdList//保存选中的数据
    @observable getCatalogByIds//对应组选中的数据
    @observable initCarseriesIds//保存选中的数据
    @observable carserList//保存选中的数据
    @observable addOrModifyLoading//保存选中的数据
    @observable selectRowIds//选中行的id
    @observable selectCatalogIdList
    @observable selectID
    @observable selectModifyID
    @observable editModal //新增||修改模態框
    @observable editTitle   //模態框名字
    @observable bySpareCount //被替换件备数量
    @observable spareCount //替换件备数量
    @observable updateCatalogIdList//保存修改的数据

    constructor() {
        this.list = []
        this.loading = false
        this.modalLoading = false
        this.carserData = []
        this.isShowModal = false
        this.isShowModal = false
        this.homePageFormData = {
            carseriesName: '',
            noticeName: '',
            noticeCode: '',
            materialNo: '',
            catalogCode: '',
            carseriesCode: '',
            spareNo: '',
        }
        this.tableData = [{
            id: 0,
            bySpareNo: '',
            byMaterialNo: '',
            bySpareName: '',
            bySpareCount: '1',
            spareNo: '',
            spareName: '',
            materialNo: '',
            spareCount: '1',
            catalogCode: '',
            carseriesName: '',
        }];
        this.editFields = {
            noticeName: '',
            carseriesCodeList: '',
            catalogIdList: '',
            replaceType: {value: 1},
            replaceStatus: '',
            oldNewStatus: '',
            saleStatus: '',
            timeliness: '',
            processingStrategy: '',
            fileUrl: '',
        }
        this.initCarCode = [];
        this.changeGroupingName = []
        this.judgeState = {}
        this.echoDisplayData = {}
        this.editingKey = ''
        this.carCodeData = ''
        this.catalogCodesData = ''
        this.saveCarceriesMapCode = ''
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.page = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.noticeNameSelectData = []
        this.fetching = false
        this.selectNoticeData = []
        this.selectLetterCode = ''
        this.selectLetterName = ''
        this.cover = ''
        this.onSearchCatalogIdListData = ''
        this.audiModal = false
        this.selectedRowKeysId = []
        this.groupModal = false
        this.selectedGroupRowKeysId = []
        this.groupList = []
        this.groupeditFields = {}
        this.getGroupData = []
        this.groupLoading = false
        this.catalogIdList = []
        this.getCatalogByIds = []
        this.initCarseriesIds = []
        this.carserList = []
        this.addOrModifyLoading = false
        this.selectRowIds = []
        this.selectCatalogIdList = []
        this.selectID = []
        this.selectModifyID = []
        this.editModal = false
        this.editTitle = ''
        this.bySpareCount = ''
        this.spareCount = ''
        this.updateCatalogIdList = []
    }


    /**
     * 主页面值绑到store
     * @param changedFields
     */
    @action
    onFieldsChange = (changedFields) => {
        this.homePageFormData = {...this.homePageFormData, ...ValueObjToObj(changedFields)}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 获取主页面数据
     * @returns {Promise<void>}
     */
    @action
    initPage = async (page) => {
        this.loading = true
        if (this.homePageFormData.carseriesName === undefined) {
            this.homePageFormData.carseriesName = ''
        }
        let search = handleSearchAndPage(page, this.pagination, this.homePageFormData)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/queryListByMap:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = Array.isArray(res.content) ? res.content : [];
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /***
     * 获取车系下拉框数据
     * @returns {Promise<void>}
     */
    @action
    editCarserData = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesCatalog/queryCarListByContent`)
        runInAction(() => {
            this.carserData = Array.isArray(res) ? res : []
        })
    }

    /**
     * 重置
     */
    @action
    clearSearch = async () => {
        this.homePageFormData = {
            carseriesName: '',
            noticeCode: '',
            materialNo: '',
            catalogCode: '',
        }
        await this.initPage()
    }

    /**
     * 通知书名称下拉搜索数据
     * @returns {Promise<void>}
     */
    @action
    noticeNameData = async () => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/letternotice/query_all_notice`)
        runInAction(() => {
            this.noticeNameSelectData = Array.isArray(res) ? res : []
        })
    }

    /**
     * 通知书名称下拉搜索匹配到的数据
     * @param value
     * @returns {Promise<void>}
     */
    @action
    noticeNameDataSearch = async (value) => {
        if (value) {
            let list = this.noticeNameSelectData.filter(item => item.letterName.indexOf(value) !== -1)
            this.selectNoticeData = list
        }
    }

    /**
     * 获取选中的通知书编号和名称
     * @param value
     */
    @action
    selectLetterCodeData = (value) => {
        this.selectLetterName = value
        let data = this.noticeNameSelectData.find(item => item.letterName === value)
        this.selectLetterCode = data.letterCode

    }

    /**
     * 新增或修改
     */
    @action
    addOrModifyData = async (record) => {
        this.isShowModal = true
        this.judgeState = record
        if (record.id) {//修改
            this.loading = true
            this.modalLoading = true
            this.editTitle = '修改'
            let id = record.id
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/getById/id/${id}`)
            if (res && res.status === 0) {
                runInAction(() => {
                    this.loading = false
                    this.modalLoading = false
                })
                return
            }
            await this.correspondingGroup(res.carseriesCodeList)
            await this.noticeNameData()
            runInAction(() => {
                this.loading = false
                this.updateCatalogIdList = res.catalogIdList
                this.editFields = {
                    ...this.editFields
                    , ...objToValueObj(res),
                    carseriesCodeList: record.carseriesNames ? {value: record.carseriesNames.split("、")} : null,
                    catalogIdList: res.frontEndGroupName ? {value: res.frontEndGroupName.split(",")} : null,
                    factoryChangeTime: {value: res.factoryChangeTime && moment(res.factoryChangeTime)}
                }
                this.editFields.replaceType = {value: res.replaceType};
                this.tableData = res.list//回显table的数据
                this.carCodeData = res.carseriesCodeList
                this.catalogCodesData = res.catalogIds
                this.initCarseriesIds = res.carseriesNames
                this.modalLoading = false
            })
        } else {//新增
            this.loading = true
            this.modalLoading = true
            this.editTitle = '新增'
            await this.noticeNameData()
            runInAction(() => {
                this.modalLoading = false
                this.loading = false
                this.tableData = [{
                    id: 0,
                    bySpareNo: '',
                    byMaterialNo: '',
                    bySpareName: '',
                    bySpareCount: '1',
                    spareNo: '',
                    spareName: '',
                    materialNo: '',
                    spareCount: '1',
                    catalogCode: '',
                    carseriesName: '',
                }];
                this.editFields = {
                    noticeName: '',
                    carseriesCodeList: '',
                    catalogIdList: '',
                    replaceType: {value: 1},
                    replaceStatus: '',
                    oldNewStatus: '',
                    saleStatus: '',
                    timeliness: '',
                    processingStrategy: '',
                    fileUrl: '',
                }
            })
        }
        this.editModal = true
    }


    /**
     * 保存添加或者修改
     * @returns {Promise<void>}
     */
    @action
    saveAddOrModify = async () => {
        this.selectID = []
        this.selectModifyID = []
        let list = Object.values(this.tableData)
        let item = ''
        list.map(i => {
            return item = i
        })
        if (!item.bySpareNo || !item.bySpareName) {
            message.warning('请填写完表格')
            return
        }
        let arr = []
        // if(this.judgeState.id){
        //     ValueObjToObj(this.editFields).catalogIdList.map(i=>{
        //         let a = this.changeGroupingName.filter(j=>j.changeGroupingName===i)
        //         return  arr.push(a.length>0&&a[0].id)
        //     })
        // }else {
        //     arr.push(this.selectRowIds[0])
        // }
        let arr1 = []
        this.tableData.map(i => {
                return arr1.push(
                    ...i,
                    i.spareCount = this.spareCount ? this.spareCount : i.spareCount,
                    i.bySpareCount = this.bySpareCount ? this.bySpareCount : i.bySpareCount
                )
            }
        )
        let data = {
            ...ValueObjToObj(this.editFields),
            list: this.tableData,
            carseriesName: this.tableData.carseriesName,
            catalogCode: this.tableData.catalogCode,
            carseriesCode: this.saveCarceriesMapCode,
            // noticeCode:this.selectLetterCode,
            // noticeName:this.selectLetterName,
            catalogIdList: arr
        }
        // data.noticeName=this.editFields.noticeName.value
        // if(this.judgeState.id){
        // let obj = this.noticeNameSelectData.find(item=>item.letterName===this.editFields.noticeName.value)
        // data.noticeCode=obj&&obj.letterCode
        // }
        if (this.judgeState.id) {//修改
            data.id = this.judgeState.id;
            data.sort = this.tableData.length;
            // data.noticeName=this.editFields.noticeName.value
            if (this.editFields.carseriesCodeList.value) {
                let arr = []
                this.editFields.carseriesCodeList.value.map(i => {
                    arr.push(this.carserData.filter(j => j.carseriesName === i))
                })
                let carSeriesCode = []
                arr.map(item => carSeriesCode.push(item[0].carSeriesCode))
                data.carseriesCodeList = carSeriesCode
                data.catalogIdList = this.selectedGroupRowKeysId.length > 0 ? this.selectedGroupRowKeysId : this.updateCatalogIdList
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/updateData`, data);
            if (res && res.status === 0) {
                message.warning('备件号在分组下不存在，请检查！')
                return
            }
        } else {//添加
            if (this.editFields.carseriesCodeList.value) {
                let arr = []
                this.editFields.carseriesCodeList.value.map(i => {
                    arr.push(this.carserData.filter(j => j.carseriesName === i))
                })
                let carSeriesCode = []
                arr.map(item => carSeriesCode.push(item[0].carSeriesCode))
                data.carseriesCodeList = carSeriesCode
                data.catalogIdList = this.selectedGroupRowKeysId
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/addSparePartChange`, data);
            if (res && res.status === 0) {
                message.warning('备件号在分组下不存在，请检查！')
                return
            }
        }
        await this.hideModel()
        await this.initPage()
    }

    /**
     * 关闭模态框
     */
    @action
    hideModel = () => {
        this.isShowModal = false
        this.tableData = [];
        this.editFields = {
            noticeName: '',
            carseriesCodeList: '',
            catalogIdList: '',
            replaceType: {value: 1},
            replaceStatus: '',
            oldNewStatus: '',
            saleStatus: '',
            timeliness: '',
            processingStrategy: '',
            fileUrl: '',
        }
        this.editingKey = ''
        this.selectNoticeData = []
        this.cover = ''
        this.catalogIdList = []
        this.initCarseriesIds = []
        this.catalogCodesData = ''
        this.selectRowIds = []
        this.editModal = false
    }

    /**
     * 删除
     */
    @action
    deleteData = async (id) => {
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/delById/id/${id}`)
        await this.initPage()
    }

    /**--------------------------------------------------------Model框--------------------------------------------------------***/
    /***
     * 编辑后保存
     * @param row
     */
    @action
    handleSaveRow = (row) => {
        const newData = [...this.tableData];
        // const index = newData.findIndex(item => row.key === item.key);
        // const item = newData[index];
        // newData.splice(index, 1, {
        //     ...item,
        //     ...row,
        // });
        this.tableData = newData
    }

    /**
     * 删除行
     * @param id
     */
    @action
    handleDeleteRow = (id) => {
        const dataSource = [...this.tableData];
        this.tableData = dataSource.filter(item => item.id !== id)
    }


    /**--------------------------------------------------------Model框--------------------------------------------------------***/

    /***
     * 将模态框页面的值绑到store
     * @param changedFields
     */
    @action
    transmitData = (changedFields) => {
        this.editFields = {...this.editFields, ...changedFields}
    }
    /**
     * 获取下拉车系code
     * @param value
     */
    @action
    changeCarseriesValue = async (value) => {
        this.loading = true
        if (value.length < 1) {
            this.catalogCodesData = ''
            this.tableData = [{
                id: 0,
                bySpareNo: '',
                byMaterialNo: '',
                bySpareName: '',
                bySpareCount: '',
                spareNo: '',
                spareName: '',
                materialNo: '',
                spareCount: '',
                catalogCode: '',
                carseriesName: '',
            }];
        }
        this.selectModifyID = []
        this.selectID = []
        let initCarData = []
        value.find(i => {
            let arr = this.carserData.find(j => j.carseriesName === i)
            initCarData.push(arr.carSeriesCode)
        })
        this.carCodeData = initCarData
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/queryByIdAndVehicleId?carseriesCodes=${initCarData}&id=${this.judgeState.id}`)
        this.editFields.catalogIdList = res.frontEndGroupName ? {value: res.frontEndGroupName.split(",")} : null
        this.selectedGroupRowKeysId = res.catalogIdList
        this.judgeState.catalogIds = res.catalogIds
        this.loading = false
        await this.correspondingGroup(initCarData, this.onSearchCatalogIdListData)
    }

    /**
     * 分组查询
     * @param value
     * @returns {Promise<void>}
     */
    @action
    changeCatalogIdListData = async (value) => {
        this.onSearchCatalogIdListData = value
        await this.correspondingGroup(this.carCodeData, this.onSearchCatalogIdListData)
    }

    /**
     * 获取对应组数据
     * @param carseriesCodes
     * @param context
     * @returns {Promise<void>}
     */
    @action
    correspondingGroup = async (carseriesCodes, context) => {
        let data = {context: context, changeId: this.judgeState.id}
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/getGroupingOptionByCarCodes?carseriesCodes=${carseriesCodes}`, data)
        runInAction(() => {
            this.changeGroupingName = Array.isArray(res) ? res : []
        })
    }

    /**--------------------------------------------------------Model框中的table--------------------------------------------------------***/


    /**
     * 获取选中的替换状态
     * @param value
     */
    @action
    changeReplaceTypeValue = (value) => {
        this.editFields.replaceType = value
        this.tableData = [{
            id: uuid(),
            bySpareNo: '',
            byMaterialNo: '',
            bySpareName: '',
            bySpareCount: '',
            spareNo: '',
            spareName: '',
            materialNo: '',
            spareCount: '',
            catalogCode: '',
            carseriesName: '',
        }]
        this.editingKey = ''
    }
    /***
     * 当替换类型不是一对多的时候可以添加table数据
     */
    @action
    addDetailsData = () => {
        let arr = this.tableData
        let endItem = arr[arr.length - 1]
        if (!endItem.bySpareNo) {
            message.warning('被替换件备件编码不能为空！');
            return
        }
        let data = {}
        if (this.editFields.replaceType.value === 2) {
            data = {
                id: uuid(),
                bySpareNo: endItem.bySpareNo,
                byMaterialNo: endItem.byMaterialNo,
                bySpareName: endItem.bySpareName,
                bySpareCount: endItem.bySpareCount,
                byCarAndCatalogCode: endItem.byCarAndCatalogCode,
                sort: this.tableData.length
            }
        } else if (this.editFields.replaceType.value === 3) {
            data = {
                id: uuid(),
                spareNo: endItem.spareNo,
                spareName: endItem.spareName,
                materialNo: endItem.materialNo,
                spareCount: endItem.spareCount,
                byCarAndCatalogCode: endItem.byCarAndCatalogCode,
                sort: this.tableData.length
            }
        } else if (this.editFields.replaceType.value === 4) {
            data = {
                id: uuid(),
                sort: this.tableData.length
            }
        }
        let list = [...this.tableData];
        list.push(data)
        this.tableData = list
    }

    /**
     * 删除行数据
     * @param id
     */
    @action
    deleteRow = (id) => {
        let list = this.tableData.slice()
        this.tableData = list.filter((i) => i.id !== id)
    }

    /**
     * 保存行数据
     * @param id
     * @param row
     */
    @action
    saveRow = (id, row) => {
        let list = this.tableData.slice()
        const index = list.findIndex(item => id === item.id)
        if (index > -1) {
            list[index] = {
                ...list[index],
                ...row
            }
        } else {
            list.push(row)
        }
        this.tableData = list
        this.editingKey = ''
    }

    /**
     * 取消编辑
     */
    @action
    cancelEditData = (id) => {
        this.editingKey = ''
        let list = this.tableData.slice()
        const index = list.findIndex(item => id === item.id)
        list[index] = {
            ...list[index],
        }
        this.tableData = list
    }

    /**
     * 被替换件备数量
     */
    @action
    echoNumberLiftRowData = async (value) => {
        this.bySpareCount = value
    }

    /**
     * 替换件备数量
     */
    @action
    echoNumberRightRowData = async (value) => {
        this.spareCount = value
    }

    /**
     * 通过被替换物料编号回显被替换件备件编号和被替换名称
     */
    @action
    echoLiftRowData = async (value, id, cover) => {
        this.cover = cover
        let nowRowList = this.tableData.slice()
        const nowRowData = nowRowList.findIndex(item => id === item.id)
        if (nowRowList[nowRowData].bySpareNo && value) {
            if (nowRowList[nowRowData].spareNo === value) {
                message.warning('替换件备件编号不能与被替换件备件编号相同')
                return
            }
        }
        let data = {
            bySpareNo: value,
        }
        if (this.editFields.carseriesCodeList.value) {
            let arr = []
            this.editFields.carseriesCodeList.value.map(i => {
                arr.push(this.carserData.filter(j => j.carseriesName === i))
            })
            let carSeriesCode = []
            arr.map(item => carSeriesCode.push(item[0].carSeriesCode))
            data.carseriesCodes = carSeriesCode
        }
        if (this.judgeState.id) {//修改
            data.catalogIds = this.catalogCodesData
        } else {//新增
            let groupIds = []
            this.getCatalogByIds.map(item => groupIds.push(item.id))
            data.catalogIds = groupIds
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/verificationReplacedPieceInfo`, data)
        if (!res.spareNo) {
            message.warning('请填写正确的被替换物料编号！')
        }
        let list = this.tableData.slice()
        const index = list.findIndex(item => id === item.id)
        list[index] = {
            ...list[index],
            byMaterialNo: res.materialNo,
            bySpareNo: res.spareNo,
            bySpareName: res.spareName,
            bySpareCount: res.epcCount,
            byCarAndCatalogCodeList: res.byCarAndCatalogConcatList
        }
        runInAction(() => {
            this.tableData = list
        })
    }

    /**
     * 通过替换件物料编号回显替换件备件编号、替换件名称、分组号、车系
     * @param value
     * @returns {Promise<void>}
     */
    @action
    echoRightRowData = async (value, id, cover) => {
        this.cover = cover
        let nowRowList = this.tableData.slice()
        const nowRowData = nowRowList.findIndex(item => id === item.id)
        if (nowRowList[nowRowData].byMaterialNo && value) {
            if (nowRowList[nowRowData].byMaterialNo === value) {
                message.warning('替换件备件编号不能与被替换件备件编号相同')
                return
            }
        }
        let data = {
            [`search.spareNo`]: value,
            [`search.carseriesCode`]: this.carCodeData,
        }
        if (this.editFields.carseriesCodeList.value) {
            let arr = []
            this.editFields.carseriesCodeList.value.map(i => {
                arr.push(this.carserData.filter(j => j.carseriesName === i))
            })
            let carSeriesCode = []
            arr.map(item => carSeriesCode.push(item[0].carSeriesCode))
                [`search.carseriesCode`] = carSeriesCode
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/checkIfTheItemExistsBasedOnTheMaterialNumber`, data)
        // if (!res.materialNo) {
        //     message.warning('替换件物料编号不存在，请检查物料编号！')
        // }
        let list = this.tableData.slice()
        const index = list.findIndex(item => id === item.id)
        list[index] = {
            ...list[index],
            materialNo: res.materialNo,
            spareNo: res.spareNo,
            spareName: res.spareName,
            // carseriesMap:res.carseriesMap,
            // catalogMap:res.catalogMap,
            spareCount: res.epcCount,
            carAndCatalogConcatList: res.carAndCatalogConcatList,
            carAndCatalogCodeList: []
        }
        runInAction(() => {
            this.tableData = list
        })
    }

    /**
     * 替换件分组号
     * @param value
     */
    @action
    groupNumber = (value, id) => {
        let list = this.tableData.slice()
        const index = list.findIndex(item => id === item.id)
        list[index] = {
            ...list[index],
            carAndCatalogCodeList: value
        }
        this.tableData = list
    }

    /**
     * 选中车系时获取code
     * @param value
     */
    @action
    saveCarseriesCode = (value) => {
        let row = this.tableData.find(item => item.id === this.editingKey)
        let carseries = row.carseriesMap ? Object.entries(row.carseriesMap) : []
        let list = carseries.find(item => item[1] === value)
        this.saveCarceriesMapCode = list[0]
    }

    /**
     * 点击编辑
     * @param id
     */
    @action
    editTableListData = (id) => {
        this.editingKey = id
    }

    /**********新增和修改是点击对应车系和对应组弹出模态框等一系列操作**********/

    /*********************************对应车系*************************************/
    /**
     * 点击对应车系模态框
     */
    @action
    selectCarseriesData = () => {
        this.audiModal = true
    }

    /***
     * 选中行的ID
     * @param selectedRowKeys
     */
    @action
    selectedRowKeys = (selectedRowKeys) => {
        this.selectedRowKeysId = selectedRowKeys
        this.carserList.push(this.selectedRowKeysId[this.selectedRowKeysId.length - 1])

    }

    /**
     * 保存选中车系将车系回显到input中
     */
    @action
    saveSelectedAudi = () => {
        //勾选中对应车系的数据
        let obj = this.initCarseriesIds.length > 0 ? this.initCarseriesIds.split('、').map(j => this.carserData.find(i => i.carseriesName === j)) : []
        let list = []
        obj.map(item => list.push(item.id))
        if (this.judgeState.id) {
            this.carserList.push(...list)
        }
        let arr = []
        this.carserList.map(i => {
            arr.push(this.carserData.filter(j => j.id === i))
        })

        let obj1 = {};
        let carseriesCodeList = []
        arr.map(item => {
            if (!obj1[item[0].carseriesName]) {
                obj1[item[0].carseriesName] = 1;
                carseriesCodeList.push(item[0].carseriesName);
            }
            return item
        })
        //勾选中对应组的数据
        this.editFields = {
            ...this.editFields,
            carseriesCodeList: {value: carseriesCodeList},
        }
        this.audiModal = false
        this.selectedRowKeysId = []
    }

    /**
     * 关闭选择对应车系模态框
     */
    @action
    closeSelectedAudi = () => {
        this.audiModal = false
        this.selectedRowKeysId = []
    }


    /********************************************对应组******************************/

    /***
     * 将模态框页面的值绑到store
     * @param changedFields
     */
    @action
    groupOnFieldsChange = (changedFields) => {
        this.groupeditFields = {...this.groupeditFields, ...ValueObjToObj(changedFields)}
    }

    /**
     * 点击对应组模态框,初始化对应组数据
     */
    @action
    selectCatalogData = async (page) => {
        this.groupModal = true
        // this.groupLoading = true
        this.addOrModifyLoading = false
        this.getCatalogByIds = []

        //对应组中的车系就是对应车系选中的车系
        this.getGroupData = this.editFields.carseriesCodeList.value

        //传车系给后台，第一次点进对应组模态框时，要将对应车系选中的车系code传到后台，
        //判断如果对应组模态中的车系名字段选择了搜索的值，选中的值将替换第一次点模态框时对应车系选中的数据

        let carseriesCodes = []
        if (this.groupeditFields.carseriesName) {//模态框中车系名选择了数据
            let obj = this.carserData.find(item => this.groupeditFields.carseriesName.includes(item.carseriesName))
            carseriesCodes = obj.carSeriesCode
        } else {//第一次点开模态框时带到后台对应车系选中的数据
            let arr = []
            this.editFields.carseriesCodeList && this.editFields.carseriesCodeList.value.map(i => {
                arr.push(this.carserData.filter(j => j.carseriesName === i))
            })
            let list = []
            arr.map(item => list.push(item[0].carSeriesCode))
            carseriesCodes = list
        }

        if (page) {
            page--
        } else if (this.page.page) {
            page = this.page.page - 1
        } else {
            page = 0
        }
        let data = {
            page: page,
            size: this.page.pageSize,
            carseriesCodes: carseriesCodes,
            code: this.groupeditFields.code,
            sparepNo: this.groupeditFields.sparepNo,
            materialCode: this.groupeditFields.materialCode
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/searchGroupByRequirement`, data)
        runInAction(() => {
            // this.groupLoading = false
            //去掉表格前面的加号图标
            res.content && res.content.map(item => delete item.children)
            this.groupList = res.content || []
            this.page = {
                current: res.number + 1,
                total: res.totalElements,
                // showQuickJumper:true,
                showSizeChanger: true,
                pageSize: res.size,
                // showTotal:()=>`总共 ${res.totalElements} 条`
            }
        })
    }

    /**
     * 重置
     */
    @action
    groupclearSearch = async () => {
        this.groupeditFields = {}
        await this.selectCatalogData()
    }

    /***
     * 选中行的ID
     * @param selectedRowKeys
     */
    @action
    selectedGroupRowKeys = (selectedRowKeys) => {
        this.selectedGroupRowKeysId = selectedRowKeys
    }

    /***
     * 保存选中车系的数据
     * @param record
     * @param selected
     */
    @action
    onStatusChangeData = (record, selected) => {
        let boo = Array.isArray(record)
        if (selected) {//选中
            if (this.judgeState.id) {//修改
                let list = this.judgeState.catalogIds ? [] : this.judgeState.catalogIds.split(',')
                // this.getCatalogByIds.map(item=>list.push(item.id))
                if (boo) {
                    this.selectModifyID.push(record.map(i => {
                        return i.id
                    }))
                } else {
                    this.selectModifyID.push(record.id)
                }
                this.selectRowIds = [...list, ...this.selectModifyID]
                this.catalogIdList = [...list, ...this.selectModifyID]
                this.catalogCodesData = [...this.selectedGroupRowKeysId]
            } else {
                if (boo) {
                    this.selectID.push(record.map(i => {
                        return i.id
                    }))
                } else {
                    this.selectID.push(record.id)
                }
                this.selectRowIds = [...this.selectID]
                this.catalogIdList = [...this.selectID]
            }
        } else {
            this.selectRowIds.remove(record.id)
            this.catalogIdList.remove(record.id)
        }
    }

    /**
     * 保存选中对应组将对应组回显到input中
     */
    @action
    saveSelectedGroup = async () => {
        this.addOrModifyLoading = false
        this.loading = true
        this.groupeditFields = {}
        if (this.judgeState.id) {
            this.catalogIdList.push(this.catalogCodesData ? this.catalogCodesData : this.catalogCodesData.split(','))
        }
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/getCatalogByIds/${this.catalogIdList}`)
        runInAction(() => {
            this.addOrModifyLoading = true
            this.getCatalogByIds = Array.isArray(res) ? res : []
            this.selectCatalogIdList = []
            this.getCatalogByIds.map(item =>
                this.selectCatalogIdList.push(item.changeGroupingName)
            )
            //勾选中对应组的数据
            this.editFields = {
                ...this.editFields,
                catalogIdList: {value: this.selectCatalogIdList},
            }
            this.groupModal = false
            this.loading = false
        })
    }


    /**
     * 关闭选择对应组模态框
     */
    @action
    closeSelectedGroup = () => {
        this.groupModal = false
        this.selectedGroupRowKeysId = []
        this.groupeditFields = {}
    }

    /***搜索表单绑值**/
    @action
    matchingExport = () => {
        let carseriesCode = this.homePageFormData.carseriesCode === undefined ? '' : this.homePageFormData.carseriesCode
        downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/change/exportExcel/carseriesCode?carseriesCode=${carseriesCode}`, '备件变更.xlsx')
        message.warning('导出中请稍等！')
    }

}

export default new epcSparepartChangeStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCSparepartChange/store.js